import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { AuthEffects } from './auth.effects'
import { AuthGuard } from './auth.guard'
import * as fromAuth from './auth.reducer'
import { AuthService } from './auth.service'
import { OidcModule } from './oidc/oidc.module'
import { OidcEffects } from './oidc/oidc.effects'
import * as fromOidc from './oidc/oidc.reducer'
import { OidcService } from './oidc/oidc.service'
@NgModule({
  declarations: [],
  exports: [],
  imports: [
    OidcModule,
    StoreModule.forFeature(fromOidc.FEATURE_NAME, fromOidc.oidcReducer),
    StoreModule.forFeature(fromAuth.FEATURE_NAME, fromAuth.authReducer),
    EffectsModule.forRoot([OidcEffects, AuthEffects])
  ],
  providers: [AuthService, AuthGuard, OidcService]
})
export class AuthModule {}
